import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractWavesColumn from './abstract-waves-column';

export class WavesItemColumn extends AbstractWavesColumn {
}
export default function () {
    registerPlugin(WavesItemColumn)
}
